
import request from '@/request'
const part_url = 'message/shortMessage/';


/**
 * 查询咨询
 *
 * @param {*} pageNum 当前页
 * @param {*} pageSize 页容
 * @returns
 */
function getPageListForUser(data) {
  let url = part_url + "getUserShortMessage";
  return request.get(url, data)
}

function getMessageContent() {
  let url = part_url + "getMessageContent";
  return request.get(url)
}

export default {
    getPageListForUser,
    getMessageContent
}



// WEBPACK FOOTER //
// ./src/api/message.js